import { render, staticRenderFns } from "./monthly-training-description.vue?vue&type=template&id=56f84e8b&scoped=true"
import script from "./monthly-training-description.ts?vue&type=script&lang=ts&external"
export * from "./monthly-training-description.ts?vue&type=script&lang=ts&external"
import style0 from "./monthly-training-description.scss?vue&type=style&index=0&id=56f84e8b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f84e8b",
  null
  
)

export default component.exports